import Generation from 'components/Generation/Generation'

export default Generation
